// ink-component
import React, { ReactNode } from 'react';
import styled, { ThemeProvider } from 'styled-components';

import getGlobalProps from '../../helpers/constants/global-props';

export interface ListProps {
  /** Content. Usually wrapped around ListItems */
  children?: ReactNode;
  /** Modifier for connected Lists */
  isConnected?: boolean;
  /** Modifier to remove the divider between ListItems */
  hasDivider?: boolean;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

/* @internal */
export const StyledList = styled.ul``;

const globalProps = getGlobalProps({});

/**
 * @purpose Splits content into items, with optional icons for visual support
 * @group List
 * @categories layout
 */
export function List(props: ListProps) {
  return props.children ? (
    <ThemeProvider
      theme={currentTheme => ({
        ...currentTheme,
        listConnected: props.isConnected,
        listHasDivider: props.hasDivider,
      })}
    >
      <StyledList {...globalProps} data-testid={props['data-testid']}>
        {props.children}
      </StyledList>
    </ThemeProvider>
  ) : null;
}

List.defaultProps = {
  children: undefined,
  isConnected: false,
  hasDivider: true,
  'data-testid': undefined,
};

List.displayName = 'List';

export default List;
